import { sprinkles } from '@design-system/sprinkles.css';
import { clsx } from 'clsx';
import { Typography } from '@design-system/components/typography/typography';
import { Button } from '@design-system/components/button/button';
import { ExamplesModal } from './ExamplesModal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Modal } from '@design-system/components/modal/modal';
import { faTriangleExclamation } from '@fortawesome/pro-solid-svg-icons';
import { ProgramCard, ProgramCardProps } from './ProgramCard';

export type PublishModalProps = {
  publish: () => void;
  showExamplesModal: boolean;
  closeExamplesModal: () => void;
  openExamplesModal: () => void;
  isOpen: boolean;
  onClose: () => void;
  alert?: string;
  firstTimePublishInfo?: string;
  programCard: ProgramCardProps;
  hideSaveAsDraft: boolean;
  isCreatorLive: boolean;
};

export const PublishModal = ({
  isOpen,
  onClose,
  showExamplesModal,
  closeExamplesModal,
  openExamplesModal,
  firstTimePublishInfo,
  alert,
  programCard,
  publish,
  hideSaveAsDraft,
  isCreatorLive,
}: PublishModalProps) => (
  <Modal
    title="Publishing Program?"
    isOpen={isOpen}
    onClose={onClose}
    modalClassName="w-full md:w-[662px]"
    centerContent
    disableBackdropClick
  >
    <div className="flex flex-col gap-6">
      <Typography variant="body" size="large">
        {isCreatorLive
          ? 'Your program is set to Publish and it will be available to your audience'
          : "Your program is set to Publish, but won't be available until your account is made live."}
      </Typography>
      <ProgramCard {...programCard} />
      {!firstTimePublishInfo ? null : (
        <Typography size="large" className="text-center font-normal">
          {firstTimePublishInfo}
        </Typography>
      )}
      {!alert ? null : (
        <div
          className={clsx(
            'flex flex-col md:flex-row rounded-[10px] px-4 py-3.5',
            sprinkles({ bg: 'D-40' }),
          )}
        >
          <div className="flex">
            <FontAwesomeIcon
              icon={faTriangleExclamation}
              className="text-[#CC7C1E] pr-2 pt-0.5"
            />
            <Typography
              variant="body"
              size="medium"
              fontWeight="normal"
              className={clsx(sprinkles({ fontWeight: 'normal' }), 'text-left')}
            >
              {alert}
            </Typography>
          </div>
          <Typography
            variant="body"
            size="medium"
            className={clsx(
              'cursor-pointer w-full md:w-[200px]',
              sprinkles({ color: 'P-80' }),
            )}
            onClick={openExamplesModal}
          >
            See examples
          </Typography>
        </div>
      )}
      <div className="flex flex-row justify-between">
        {hideSaveAsDraft ? null : (
          <Button
            variant="text"
            color="neutral"
            onClick={onClose}
            className="w-[275px]"
          >
            Save draft
          </Button>
        )}
        <Button color="neutral" onClick={publish} className="w-[275px]">
          Yes, publish
        </Button>
      </div>
      <ExamplesModal isOpen={showExamplesModal} close={closeExamplesModal} />
    </div>
  </Modal>
);
